<p-blockUI [blocked]="isLoading">
  <div class="p-d-inline-flex p-flex-column p-ai-center">
    <p-progressSpinner></p-progressSpinner>
    <span class="loading-text">loading</span>
  </div>
</p-blockUI>
